import React from "react";

import styles from "./List.module.css";

export const List: React.FC<ReactElement> = ({ children, className }) => {
  const styling = `${styles.list} ${className}`;

  return (
    <ul className={styling}>
      {children}
    </ul>
  );
};